import React from 'react'
import { Box, Typography, Tooltip } from '@mui/material'
import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'
import { MODAL_Z_INDEX } from '../../../../shared/components/DefaultModal'

interface DemographicChoiceButtonProps {
  label: string
  selected: boolean
  onClick: () => void
  tooltip?: string
}

export const DemographicChoiceButton: React.FC<DemographicChoiceButtonProps> = ({
  label,
  selected,
  onClick,
  tooltip
}) => {
  const button = (
    <Box
      onClick={onClick}
      sx={{
        px: 2.5,
        py: 1.25,
        borderRadius: '999px',
        border: selected ? `2px solid ${INTERAX_COLORS.sun}` : `1px solid rgba(255,255,255,0.15)`,
        backgroundColor: selected ? INTERAX_COLORS.sun10 : 'transparent',
        cursor: 'pointer',
        transition: 'all 0.15s ease-in-out',
        '&:hover': {
          borderColor: INTERAX_COLORS.sun40,
          backgroundColor: INTERAX_COLORS.sun10
        }
      }}
    >
      <Typography
        sx={{
          ...INTERAX_TYPOGRAPHY.body2,
          color: selected ? INTERAX_COLORS.sun : INTERAX_COLORS.white,
          fontWeight: selected ? 600 : 400,
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </Typography>
    </Box>
  )

  if (!tooltip) return button

  return (
    <Tooltip title={tooltip} placement="top" arrow PopperProps={{ sx: { zIndex: MODAL_Z_INDEX + 1 } }}>
      {button}
    </Tooltip>
  )
}
